<template>
    <div class="content-section">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-10">
                    <div class="collapse-section"
                         :class="{
                            'open-collapse': collapsible,
                            'close-collapse': !collapsible
                          }"
                    :style="collapsseStyle()"
                    >
                        <h1>Get offers on electricity from several suppliers in Stockholm</h1>
                        <p>Tecknael.se is a free tender service without bindings. You fill out the form and the companies that supply electricity in the Stockholm area are competing to give you their lowest price.</p>
                        <h3>The electricity market in the Stockholm region:</h3>
                        <page-navigation miniNav="true"></page-navigation>
                        <h3>Elavtal Stockholm</h3>


                        <p>Söker du elavtal i Stockholmsområdet? I så fall gör du rätt i att använda dig av TecknaEl. Med TecknaEl jämför du enkelt elavtal från olika elbolag i Stockholm. På så vis kan du få billig el i Stockholm och spara hundralappar på elräkningen varje månad. Hos oss byter du elavtal snabbt och enkelt. Dessutom är TecknaEl helt kostnadsfri - så att du ska kunna jämföra elavtal i Stockholm och hitta rätt val för dig, utan någon press. Bli ett av de hushåll som har sänkt sina månadskostnader med hjälp av TecknaEl!</p>

                        <h3>Hitta det bästa och billigaste elavtalet i Stockholm</h3>




                        <p>Att hitta det bästa och billigaste elavtalet i Stockholm har länge verkat som en omöjlig uppgift. Med TecknaEl blir dock detta en verklighet. Det finns många konkurrerande elbolag i Stockholm och det kan vara snårigt att hitta bäst deal bland alla dessa. På TecknaEl kan du enkelt och lätt jämföra elbolag i Stockholm för att hitta billigast elavtal. Dessutom kan du välja precis den typ av el du vill ha. Vill du ha klimatsmart, fossilfri el till din lägenhet eller villa i Stockholm? Genom TecknaEl kan du jämföra vad för typ av el de olika företagen erbjuder, oavsett om du bor på Södermalm, Kungsholmen, i Bromma eller någon annan del av Stockholm - utan att det kostar dig ett öre.</p>
                        <h3>Jämför elavtal i Stockholm</h3>
                        <p>De allra flesta misstänker nog att de hade kunnat sänka sina månatliga elkostnader om de verkligen. Det kan dock kännas krångligt att sätta sig in i elmarknaden och manuellt jämföra de olika elbolagen i Stockholm. Med TecknaEl så kan du själv undersöka elmarknaden i Stockholm på några få knapptryck. Du väljer själv vad du vill ha för typ av elavtal - så ger TecknaEl dig verktygen för att jämföra dem. Oavsett om du vill ha rörligt elavtal, fast elavtal, eller el till mixpris i Stockholm så finns vi här för dig!</p>
                        <h3>Elmarknaden i Stockholmsområdet </h3>
                        <p>I Stockholm finns det över 100 olika elhandelsbolag. Dessutom finns det flera olika nätägare, vilket är dem som äger och underhåller ditt lokala elnät. Du kan inte ändra din nätägare, men däremot kan du byta elhandelsbolag och därigenom ditt elavtal. Det är dock svårt att veta vilka elbolag som är billigast, mest klimatsmarta, eller helt enkelt bäst i Stockholm. Stockholm befinner sig i elområde SE3, vilket generellt är ett av de dyrare elområdena i Sverige. Det blir därför extra viktigt att ha en pålitlig och enkel tjänst för att kunna jämföra elavtal i Stockholm. Detta är precis vad TecknaEl erbjuder.</p>

                    </div>
                    <div class="read-more" :class="{'open-read': collapsible}">

                        <button class="open-full-btn" @click="openCSection()">{{textReadMore}}
                            <img src="/img/icon/arrow_round.svg" alt="">
                        </button>
                        <p style="text-align: center">
                            <button>Get cheaper electricity now</button>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import PageNavigation from './pageNavigation'

    export default {
        name: "ContentPart",
        data:function(){
            return {
                collapsible: false,
                windowWidth: 0,
                textReadMore: 'Read more',
            }
        },
        components:{
            PageNavigation
        },
        methods: {
            collapsseStyle(){
                if(this.collapsible){
                    return {height: 'auto',}
                } else {
                    return {height: '300px',}
                }
            },
            openCSection(){
                if(this.collapsible){
                    this.collapsible = false;
                    this.textReadMore = 'Read more';
                } else {
                    this.collapsible = true;
                    this.textReadMore = 'Read less';
                }
                console.log('123');

            },
            handleResize(){
                this.windowWidth = window.innerWidth;
                if(this.windowWidth > 773){
                    this.collapsible = true;
                    this.textReadMore = 'Read less';
                } else {
                    this.collapsible = false;
                    this.textReadMore = 'Read more';
                }
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>

